import styled from 'styled-components'
import { Anchor } from 'ui/core'

export const StyledAnchor = styled(Anchor)`
  height: 100%;
  padding-top: 2px;
  padding-left: 2px;
`
